export const getDefaultMasterCodeTypeObj = (type="type") => ({
    id: null,
    type: type,
    typeShortDescription: "",
    typeLongDescription: "",
    category: "",
    active: true,
  });
  